module.exports = __webpack_public_path__ + "static/media/od_12.026a14bf.jpg";